import qs from 'qs';
import getIsIOS from 'utils/getIsIOS';
import { isMobileMedia } from 'utils/media';

const MAPS_DOMAIN = 'google.com';
const SEARCH_PARAMS = '/maps/search/';

export const openAddress = ({ lat, lng, address, googlePlaceId }) => {
  window.open(buildMapUri({ lat, lng, address, googlePlaceId }));
};

/**
 * Build a uri for Google Maps search
 * See https://developers.google.com/maps/documentation/urls/guide#search-action
 */
/**
 * Open an address in Google Maps
 * See https://developers.google.com/maps/documentation/urls/guide#search-action
 */
export const buildMapUri = ({ lat, lng, address, googlePlaceId }) => {
  const payload = lat && lng ? `${lat},${lng}` : address;

  // we include a google_place id if there is one associated with thjis location
  const queryString = qs.stringify({
    api: 1,
    query: payload,
    query_place_id: googlePlaceId
  });
  const isIOS = getIsIOS();
  const protocol = isIOS ? 'maps://' : 'https://';
  const subdomain = isIOS ? 'maps.' : 'www.';
  return `${protocol}${subdomain}${MAPS_DOMAIN}${SEARCH_PARAMS}?${queryString}`;
};

const getAddress = (street, city, state, postalCode) =>
  `${street} ${city} ${state} ${postalCode}`;

export const getHandleAddress = ({
  street,
  city,
  state,
  postalCode,
  googlePlaceId
}) => {
  if (isMobileMedia()) {
    return () =>
      openAddress({
        address: getAddress(street, city, state, postalCode),
        googlePlaceId
      });
  }
};
